import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const dict = {
    ro: {
        nav: {
            features: "Funcții",
            how: "Cum funcționează",
            useCases: "Cazuri de utilizare",
            order: "Comandă",
            login: "Autentificare",
            dashboard: "Contul meu",
            logout: "Ieșire",
        },
        hero: {
            tag: "Brățara inteligentă cu cod QR",
            title1: "Siguranța lor,",
            title2: "la o scanare distanță.",
            sub: "O brățară elegantă cu cod QR unic. Scanată cu orice telefon, afișează instant informațiile medicale și contactele de urgență.",
            ctaPrimary: "Comandă acum — 49 RON",
            ctaSecondary: "Cum funcționează",
            trust: "Fără abonament • Profil editabil oricând • Transportul nu este inclus",
            scanBadge: "SCAN",
            scanResult: "→ Profil",
            scanSpeed: "~ 1.2s pe orice telefon",
        },
        how: {
            title: "Trei pași simpli",
            sub: "De la cumpărare la siguranță, în câteva minute.",
            s1Title: "Comandă brățara",
            s1Desc: "Alege modelul, completează datele de livrare. Plătești la primire.",
            s2Title: "Activează online",
            s2Desc: "Creează un cont cu email și parolă. Completează datele medicale și contactele de urgență.",
            s3Title: "Salvează vieți",
            s3Desc: "Oricine scanează codul QR vede instant informațiile vitale și poate suna direct.",
        },
        features: {
            title: "Construită pentru orice situație",
            sub: "Pentru copii, vârstnici, sportivi sau pacienți cronici — protecția nu doarme.",
            f1Title: "Profil editabil oricând",
            f1Desc: "Schimbi medicamentele, alergiile sau contactele direct din contul tău.",
            f2Title: "Cod QR pe viață",
            f2Desc: "Același cod, oricâte actualizări. Nu trebuie să cumperi alta când se schimbă datele.",
            f3Title: "Funcționează offline pentru scanner",
            f3Desc: "Salvatorul are nevoie doar de camera telefonului — nicio aplicație de instalat.",
            f4Title: "Rezistentă la apă",
            f4Desc: "Silicon medical, rezistă la duș, înot, sport intens. Durata de viață peste 3 ani.",
            f5Title: "Date private, sub controlul tău",
            f5Desc: "Tu decizi ce afișezi. Dezactivezi brățara din cont dacă o pierzi.",
            f6Title: "Românește & English",
            f6Desc: "Profilul poate fi afișat bilingv pentru turiști și călătorii străini.",
            f7Title: "Modul eveniment",
            f7Desc: "Conectezi brățara la un link extern: festival, concert, scenă, hartă sau bilet. Un singur scan, totul afișat instant.",
        },
        useCases: {
            title: "Pentru cine este?",
            sub: "Oricine vrea liniștea că, într-o secundă critică, datele potrivite ajung la oamenii potriviți.",
            uc1: "Copii & adolescenți",
            uc1Desc: "La școală, în tabără, la antrenamente — părintele e mereu la un apel distanță.",
            uc2: "Persoane vârstnice",
            uc2Desc: "Alzheimer, dezorientare, căderi. Informația medicală e la îndemâna oricărui trecător.",
            uc3: "Sportivi & alergători",
            uc3Desc: "Identificare instant pe traseu. Grupa sanguină, contacte, alergii — toate într-un scan.",
            uc4: "Pacienți cronici",
            uc4Desc: "Medicamentele și diagnosticele clare pentru personalul ambulanței.",
            uc5: "Tabără & vacanță la mare",
            uc5Desc: "Dacă cel mic se pierde de părinți la plajă, în parc sau în excursie, oricine îl găsește îți poate suna direct.",
            uc6: "Drumeții & munte",
            uc6Desc: "Trasee montane, alpinism, ciclism off-road. În caz de accident, salvamontul are instant grupa sanguină și contacte.",
            uc7: "Festivaluri & concerte",
            uc7Desc: "Conectează brățara la un link cu detalii eveniment, hartă, scenă sau bilet — un singur scan și totul e acolo.",
            uc8: "Animale de companie",
            uc8Desc: "Atașată la zgârnicia câinelui sau a pisicii — cel care îl găsește vede instant cum să te contacteze.",
        },
        order: {
            title: "Comandă brățara ta",
            sub: "Completează formularul. Te contactăm pentru confirmare în maxim 24 de ore. Plata la livrare.",
            name: "Nume și prenume",
            phone: "Telefon",
            email: "Email (opțional)",
            address: "Adresă completă",
            qty: "Cantitate",
            notes: "Observații (opțional)",
            cta: "Trimite comanda",
            success: "Mulțumim! Te contactăm în curând pentru confirmare.",
            fieldRequired: "Acest câmp este obligatoriu",
            emailInvalid: "Adresa de email nu este validă",
            price: "49 RON / bucată",
            priceNote: "Transportul nu este inclus",
            b1: "Silicon medical, rezistent la apă",
            b2: "Cod QR unic, gravat permanent",
            b3: "Cont online inclus — fără abonament",
            b4: "Livrare 2-4 zile, plată la curier",
        },
        auth: {
            loginTitle: "Bun venit înapoi",
            loginSub: "Intră în contul tău pentru a edita datele brățării.",
            registerTitle: "Creează cont",
            registerSub: "Pentru a-ți activa brățara, ai nevoie de un cont cu email și parolă.",
            email: "Email",
            password: "Parolă",
            name: "Nume",
            login: "Autentifică-te",
            register: "Înregistrează-te",
            noAccount: "Nu ai cont?",
            hasAccount: "Ai deja cont?",
            forgot: "Ai uitat parola?",
            forgotTitle: "Resetează parola",
            forgotSub: "Introdu emailul. Îți trimitem un link pentru a-ți seta o parolă nouă.",
            forgotSend: "Trimite link",
            forgotDone: "Dacă există un cont cu acest email, ți-am trimis un link de resetare.",
            resetTitle: "Setează parola nouă",
            resetSub: "Alege o parolă de minim 6 caractere.",
            newPassword: "Parolă nouă",
            resetCta: "Salvează parola",
            resetDone: "Parola a fost actualizată. Te poți autentifica.",
        },
        dashboard: {
            title: "Brățările mele",
            sub: "Activează o brățară nouă sau actualizează datele unei brățări existente.",
            claim: "Adaugă o brățară",
            claimDesc: "Ai primit o brățară cu un cod imprimat? Introdu codul aici.",
            claimCode: "Cod brățară",
            claimLabel: "Etichetă (ex: pentru tata)",
            claimCta: "Activează",
            createCta: "Generează cod nou",
            empty: "Nu ai brățări activate. Activează una de mai sus.",
            edit: "Editează profil",
            view: "Vezi pagina QR",
            qrLink: "Link QR",
            active: "Activă",
            inactive: "Dezactivată",
            saveProfile: "Salvează profilul",
            deactivate: "Dezactivează",
            activate: "Activează",
            delete: "Șterge",
            profile: {
                fullName: "Nume complet",
                dob: "Data nașterii",
                bloodType: "Grupa sanguină",
                allergies: "Alergii",
                conditions: "Boli cronice / Diagnostice",
                medications: "Medicamente curente",
                address: "Adresă",
                notes: "Note pentru salvator",
                ec1Name: "Contact de urgență 1 — Nume",
                ec1Phone: "Contact de urgență 1 — Telefon",
                ec2Name: "Contact de urgență 2 — Nume",
                ec2Phone: "Contact de urgență 2 — Telefon",
                eventTitle: "Titlu eveniment / link (opțional)",
                websiteUrl: "Link web (ex: pagină eveniment, profil, bilet)",
            },
        },
        scan: {
            emergency: "PROFIL DE URGENȚĂ",
            callNow: "Sună acum",
            allergies: "ALERGII",
            conditions: "AFECȚIUNI MEDICALE",
            medications: "MEDICAMENTE",
            blood: "GRUPA SANGUINĂ",
            dob: "DATA NAȘTERII",
            notes: "NOTE",
            address: "ADRESĂ",
            contacts: "CONTACTE DE URGENȚĂ",
            openLink: "Deschide linkul",
            unclaimed: "Această brățară nu a fost activată încă.",
            inactive: "Această brățară este dezactivată de proprietar.",
        },
        footer: {
            rights: "Toate drepturile rezervate.",
            tagline: "Brățara care vorbește când cei dragi nu pot.",
        },
    },
    en: {
        nav: {
            features: "Features",
            how: "How it works",
            useCases: "Use cases",
            order: "Order",
            login: "Log in",
            dashboard: "My account",
            logout: "Log out",
        },
        hero: {
            tag: "Smart QR bracelet",
            title1: "Their safety,",
            title2: "one scan away.",
            sub: "An elegant bracelet with a unique QR code. Scanned by any phone, it instantly shows medical info and emergency contacts.",
            ctaPrimary: "Order now — 10 EUR",
            ctaSecondary: "How it works",
            trust: "No subscription • Edit anytime • Shipping not included",
            scanBadge: "SCAN",
            scanResult: "→ Profile",
            scanSpeed: "~ 1.2s on any phone",
        },
        how: {
            title: "Three simple steps",
            sub: "From purchase to safety, in minutes.",
            s1Title: "Order the bracelet",
            s1Desc: "Pick your model, fill in delivery details. Pay on delivery.",
            s2Title: "Activate online",
            s2Desc: "Create an account with email and password. Fill in medical data and emergency contacts.",
            s3Title: "Save lives",
            s3Desc: "Anyone who scans the QR code instantly sees vital info and can call directly.",
        },
        features: {
            title: "Built for every moment",
            sub: "For children, seniors, athletes or chronic patients — protection never sleeps.",
            f1Title: "Editable anytime",
            f1Desc: "Update medications, allergies or contacts directly from your account.",
            f2Title: "Lifetime QR code",
            f2Desc: "Same code, unlimited updates. No need to buy a new bracelet.",
            f3Title: "Works without an app",
            f3Desc: "The rescuer only needs a phone camera — nothing to install.",
            f4Title: "Waterproof",
            f4Desc: "Medical-grade silicone. Survives showers, swimming, intense workouts.",
            f5Title: "Private, your control",
            f5Desc: "You decide what's shown. Deactivate from your account if lost.",
            f6Title: "Romanian & English",
            f6Desc: "Bilingual profile for travelers and foreign rescuers.",
            f7Title: "Event mode",
            f7Desc: "Link the bracelet to an external URL: festival, concert, stage, map or ticket. One scan, everything instantly.",
        },
        useCases: {
            title: "Who is it for?",
            sub: "Anyone who wants peace of mind that, in a critical second, the right data reaches the right people.",
            uc1: "Kids & teens",
            uc1Desc: "At school, in camp, at training — parents are always a call away.",
            uc2: "Seniors",
            uc2Desc: "Alzheimer's, disorientation, falls. Medical info is in any passerby's hand.",
            uc3: "Athletes & runners",
            uc3Desc: "Instant ID on the trail. Blood type, contacts, allergies — all in one scan.",
            uc4: "Chronic patients",
            uc4Desc: "Clear meds and diagnoses for ambulance crews.",
            uc5: "Camps & seaside",
            uc5Desc: "If your child wanders off at the beach, park or on a trip, whoever finds them can call you directly.",
            uc6: "Hiking & mountains",
            uc6Desc: "Mountain trails, climbing, off-road biking. In an accident, rescue teams instantly see blood type and contacts.",
            uc7: "Festivals & concerts",
            uc7Desc: "Link the bracelet to an event page, map, stage info or ticket — one scan and everything is right there.",
            uc8: "Pets",
            uc8Desc: "Attached to the collar of a dog or cat — whoever finds them sees instantly how to reach you.",
        },
        order: {
            title: "Order your bracelet",
            sub: "Fill out the form. We'll contact you within 24 hours to confirm. Pay on delivery.",
            name: "Full name",
            phone: "Phone",
            email: "Email (optional)",
            address: "Full address",
            qty: "Quantity",
            notes: "Notes (optional)",
            cta: "Send order",
            success: "Thank you! We'll reach out soon to confirm.",
            fieldRequired: "This field is required",
            emailInvalid: "Email address is not valid",
            price: "10 EUR / piece",
            priceNote: "Shipping not included",
            b1: "Medical-grade silicone, waterproof",
            b2: "Unique QR code, permanently engraved",
            b3: "Online account included — no subscription",
            b4: "Delivery 2-4 days, pay on delivery",
        },
        auth: {
            loginTitle: "Welcome back",
            loginSub: "Sign in to edit your bracelet data.",
            registerTitle: "Create account",
            registerSub: "To activate your bracelet you need an email & password account.",
            email: "Email",
            password: "Password",
            name: "Name",
            login: "Log in",
            register: "Sign up",
            noAccount: "No account?",
            hasAccount: "Already have an account?",
            forgot: "Forgot password?",
            forgotTitle: "Reset password",
            forgotSub: "Enter your email. We'll send you a link to set a new password.",
            forgotSend: "Send link",
            forgotDone: "If an account with this email exists, we sent a reset link.",
            resetTitle: "Set new password",
            resetSub: "Choose a password of at least 6 characters.",
            newPassword: "New password",
            resetCta: "Save password",
            resetDone: "Password updated. You can sign in now.",
        },
        dashboard: {
            title: "My bracelets",
            sub: "Activate a new bracelet or update an existing one.",
            claim: "Add a bracelet",
            claimDesc: "Got a bracelet with a printed code? Enter the code here.",
            claimCode: "Bracelet code",
            claimLabel: "Label (e.g. for dad)",
            claimCta: "Activate",
            createCta: "Generate new code",
            empty: "No bracelets activated yet. Add one above.",
            edit: "Edit profile",
            view: "View QR page",
            qrLink: "QR link",
            active: "Active",
            inactive: "Disabled",
            saveProfile: "Save profile",
            deactivate: "Deactivate",
            activate: "Activate",
            delete: "Delete",
            profile: {
                fullName: "Full name",
                dob: "Date of birth",
                bloodType: "Blood type",
                allergies: "Allergies",
                conditions: "Chronic conditions / Diagnoses",
                medications: "Current medications",
                address: "Address",
                notes: "Notes for rescuer",
                ec1Name: "Emergency contact 1 — Name",
                ec1Phone: "Emergency contact 1 — Phone",
                ec2Name: "Emergency contact 2 — Name",
                ec2Phone: "Emergency contact 2 — Phone",
                eventTitle: "Event title / link label (optional)",
                websiteUrl: "Web link (e.g. event page, profile, ticket)",
            },
        },
        scan: {
            emergency: "EMERGENCY PROFILE",
            callNow: "Call now",
            allergies: "ALLERGIES",
            conditions: "MEDICAL CONDITIONS",
            medications: "MEDICATIONS",
            blood: "BLOOD TYPE",
            dob: "DATE OF BIRTH",
            notes: "NOTES",
            address: "ADDRESS",
            contacts: "EMERGENCY CONTACTS",
            openLink: "Open link",
            unclaimed: "This bracelet has not been activated yet.",
            inactive: "This bracelet has been deactivated by its owner.",
        },
        footer: {
            rights: "All rights reserved.",
            tagline: "The bracelet that speaks when loved ones can't.",
        },
    },
};

const I18nContext = createContext({ lang: "ro", t: dict.ro, setLang: () => {} });

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "ro";
        return localStorage.getItem("qrb_lang") || "ro";
    });
    const setLang = useCallback((l) => {
        setLangState(l);
        try { localStorage.setItem("qrb_lang", l); } catch (e) {}
    }, []);
    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);
    const t = dict[lang] || dict.ro;
    return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
    return useContext(I18nContext);
}
